import PubSub from "underpub-js";

var CardOne = function(options) {

	this.options = {
		$el: false,
		baseClass: 'el-CardOne',
	};

	$.extend(true, this.options, options);

};

CardOne.prototype.init = function() {

	var self = this;

};

export default CardOne;
